/**
 * Canonical route table. Clients build URLs from here, never from string literals.
 *
 * Note there is no separate "scan events" endpoint. Progressive results are
 * streamed from the `POST /v1/scans` request itself when the client sends
 * `Accept: text/event-stream`, which saves a round trip on the one path where
 * latency actually matters. Every route listed here is implemented; a contract
 * that advertises a 404 is worse than no contract.
 */
export const API_VERSION = 'v1';
export const ROUTES = {
    health: `/${API_VERSION}/health`,
    status: `/${API_VERSION}/status`,
    config: `/${API_VERSION}/config`,
    register: `/${API_VERSION}/auth/register`,
    login: `/${API_VERSION}/auth/login`,
    refresh: `/${API_VERSION}/auth/refresh`,
    me: `/${API_VERSION}/auth/me`,
    logout: `/${API_VERSION}/auth/logout`,
    passwordResetRequest: `/${API_VERSION}/auth/password-reset/request`,
    passwordResetConfirm: `/${API_VERSION}/auth/password-reset/confirm`,
    scans: `/${API_VERSION}/scans`,
    scan: (id) => `/${API_VERSION}/scans/${id}`,
    scanFeedback: (id) => `/${API_VERSION}/scans/${id}/feedback`,
    scanSave: (id) => `/${API_VERSION}/scans/${id}/save`,
    comps: `/${API_VERSION}/comps`,
    comp: (id) => `/${API_VERSION}/comps/${id}`,
    valuations: `/${API_VERSION}/valuations`,
    cardSearch: `/${API_VERSION}/cards/search`,
    watchlist: `/${API_VERSION}/watchlist`,
    watchlistItem: (id) => `/${API_VERSION}/watchlist/${id}`,
    usage: `/${API_VERSION}/usage`,
    entitlements: `/${API_VERSION}/entitlements`,
    plans: `/${API_VERSION}/plans`,
    billingCheckout: `/${API_VERSION}/billing/checkout`,
    billingApple: `/${API_VERSION}/billing/apple/verify`,
    stripeWebhook: `/${API_VERSION}/webhooks/stripe`,
    appleWebhook: `/${API_VERSION}/webhooks/apple`,
    privacyExport: `/${API_VERSION}/privacy/export`,
    privacyDelete: `/${API_VERSION}/privacy/delete`,
};
/**
 * Paths in the web client that the API links to from outside the app — today
 * only from email.
 *
 * These live in contracts because the two ends are deployed separately: the
 * API builds the URL, the SPA declares the route, and nothing at build time
 * connects them. The reset link shipped once pointing at a route that did not
 * exist, which produced a working email leading to "Page not found".
 */
export const APP_PATHS = {
    resetPassword: '/reset-password',
    forgotPassword: '/forgot-password',
    signIn: '/signin',
};
export const SCAN_ERROR_CODES = {
    unauthorized: 'unauthorized',
    quotaExceeded: 'quota_exceeded',
    imageTooLarge: 'image_too_large',
    unsupportedImageType: 'unsupported_image_type',
    imageUnusable: 'image_unusable',
    identificationFailed: 'identification_failed',
    compsUnavailable: 'comps_unavailable',
    providerTimeout: 'provider_timeout',
    internal: 'internal_error',
    validation: 'validation_error',
    rateLimited: 'rate_limited',
};
//# sourceMappingURL=routes.js.map